import script from "./categoryTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./categoryTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./categoryTemplate.vue?vue&type=style&index=0&id=0988b2b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0988b2b6"]])

export default __exports__